/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon} from '../../../helpers'

type Props = {
  className: string
  color: string
  svgIcon: string
  iconColor: string
  title: string
  titleColor?: string
  description: string
  descriptionColor?: string,
  optional?: string
}

const StatisticsWidget5: React.FC<Props> = ({
  className,
  color,
  svgIcon,
  iconColor,
  title,
  titleColor,
  description,
  optional,
  descriptionColor,
}) => {
  return (
      <div className={`card-body card bg-${color} hoverable ${className}`}>
        <KTIcon iconName={svgIcon} className={`text-${iconColor} fs-3x ms-n1`} />

        <div className={`text-${titleColor} fw-bold fs-2 mb-2 mt-5`}>{title}</div>

        <div className={`fw-bold fs-5 text-${descriptionColor}`}>{description}</div>
        {optional && <div className={`fw-semibold fs-6 text-${descriptionColor}`}>{optional}</div> }
      </div>
  )
}

export {StatisticsWidget5}
